module.exports = __webpack_public_path__ + "img/375.12ef8191.jpg";